import axiosInstance from '../axiosInstance';

const getAllPatterns = async () => {
  return axiosInstance.get('/green/pattern').then((response) => {
    return response.data;
  });
};

const getPatternById = async (id) => {
  return axiosInstance.get(`/green/pattern/${id}`).then((response) => {
    return response.data;
  });
};

const createPattern = async (data) => {
  return axiosInstance.post('/green/pattern', data).then((response) => {
    return response.data;
  });
};

const updatePattern = async (id, data) => {
  return axiosInstance.put(`/green/pattern/${id}`, data).then((response) => {
    return response.data;
  });
};

const deletePattern = async (id) => {
  return axiosInstance.delete(`/green/pattern/${id}`).then((response) => {
    return response.data;
  });
};

const getGreenPlayerInformation = async (eventId) => {
  return axiosInstance.get(`/green/green-player-information/${eventId}`).then((response) => {
    return response.data;
  });
};

const greenService = {
  getAllPatterns,
  getPatternById,
  createPattern,
  updatePattern,
  deletePattern,
  getGreenPlayerInformation
};

export default greenService;
